
export default {
    api: {
        mutations: {
            push: 'MUTATION_API_PUSH',
            pop: 'MUTATION_API_POP',
            errorCode: 'MUTATION_API_ERROR_CODE'
        },
        actions: {
            push: 'ACTION_API_PUSH',
            pop: 'ACTION_API_POP',
            errorCode: 'ACTION_API_ERROR_CODE'
        },
        getters: {
            apiState: 'GETTER_API_STATE',
            isRunning: 'GETTER_IS_RUNNING',
            errorCode: 'GETTER_ERROR_CODE'
        }
    },
    appState: {
        mutations: {
            updateWidth: 'MUTATION_APP_STATE_WIDTH_UPDATE',
            updateOffsetY: 'MUTATION_APP_STATE_OFFSET_Y_UPDATE',
            updateAppMode: 'MUTATION_APP_STATE_APP_MODE_UPDATE',
            updateScrolled: 'MUTATION_APP_STATE_SCROLLED_UPDATE',
            updateRendered: 'MUTATION_APP_STATE_RENDERED_UPDATE',
            updateLanguage: 'MUTATION_APP_STATE_LANGUAGE'
        },
        actions: {
            updateWidth: 'ACTION_APP_STATE_WIDTH_UPDATE',
            updateRendered: 'ACTION_APP_STATE_RENDERED',
            updateOffsetY: 'ACTION_APP_STATE_OFFSET_Y_UPDATE',
            updateLanguage: 'ACTION_APP_STATE_UPDATE_LANGUAGE'
        },
        getters: {
            getWidth: 'GETTER_APP_STATE_WIDTH_GET',
            getOffsetY: 'GETTER_APP_STATE_OFFSET_Y',
            getAppMode: 'GETTER_APP_STATE_APP_MODE_GET',
            isRendered: 'GETTER_APP_STATE_IS_RENDERED',
            isPC: 'GETTER_APP_STATE_IS_PC',
            isScrolled: 'GETTER_APP_STATE_IS_SCROLLED',
            language: 'GETTER_APP_STATE_LANGUAGE'
        }
    },
    appBar: {
        mutations: {
            updateWhite: 'MUTATION_APP_BAR_WHITE_UPDATE',
            menuBtn: 'MUTATION_APP_BAR_MENU_BTN',
            utilBtn: 'MUTATION_APP_BAR_UTIL_BTN',
            backBtn: 'MUTATION_APP_BAR_BACK_BTN',
            homeBtn: 'MUTATION_APP_BAR_HOME_BTN',
            drawer: 'MUTATION_APP_BAR_DRAWER',
            title: 'MUTATION_APP_BAR_TITLE',
            hide: 'MUTATION_APP_BAR_HIDE',
            color: 'MUTATION_APP_BAR_COLOR'
        },
        actions: {
            updateWhite: 'ACTION_APP_BAR_WHITE_UPDATE',
            menuBtn: 'ACTION_APP_BAR_MENU_BTN_UPDATE',
            utilBtn: 'ACTION_APP_BAR_UTIL_BTN',
            backBtn: 'ACTION_APP_BAR_BACK_BTN',
            homeBtn: 'ACTION_APP_BAR_HOME_BTN',
            drawer: 'ACTION_APP_BAR_DRAWER',
            title: 'ACTION_APP_BAR_TITLE',
            hide: 'ACTION_APP_BAR_HIDE',
            color: 'ACTION_APP_BAR_COLOR'
        },
        getters: {
            getWhite: 'GETTER_APP_BAR_WHITE_GET',
            menuBtn: 'GETTER_APP_BAR_MENU_BTN',
            utilBtn: 'GETTER_APP_BAR_UTIL_BTN',
            backBtn: 'GETTER_APP_BAR_BACK_BTN',
            homeBtn: 'GETTER_APP_BAR_HOME_BTN',
            drawer: 'GETTER_APP_BAR_DRAWER',
            title: 'GETTER_APP_BAR_TITLE',
            hide: 'GETTER_APP_BAR_HIDE',
            color: 'GETTER_APP_BAR_COLOR'
        }
    },
    snackBar: {
        mutations: {
            show: 'MUTATION_SNACK_BAR_SHOW',
            disappear: 'MUTATION_SNACK_BAR_DISAPPEAR'
        },
        actions: {
            show: 'ACTION_SNACK_BAR_SHOW',
            disappear: 'ACTION_SNACK_BAR_DISAPPEAR'
        },
        getters: {
            model: 'GETTER_SNACK_BAR_MODEL',
            text: 'GETTER_SNACK_BAR_TEXT',
            color: 'GETTER_SNACK_BAR_COLOR'
        }
    },
    addItem: {
        mutations: {
            section1: 'MUTATION_ADD_ITEM_SECTION1',
            section2: 'MUTATION_ADD_ITEM_SECTION2',
            section3: 'MUTATION_ADD_ITEM_SECTION3',
            section4: 'MUTATION_ADD_ITEM_SECTION4',
            clearAll: 'MUTATION_ADD_ITEM_CLEAR_ALL',
            fetchCheckup: 'MUTATION_ADD_ITEM_FETCH_CHECKUP'
        },
        actions: {
            section1: 'ACTION_ADD_ITEM_SECTION1',
            section2: 'ACTION_ADD_ITEM_SECTION2',
            section3: 'ACTION_ADD_ITEM_SECTION3',
            section4: 'ACTION_ADD_ITEM_SECTION4',
            clearAll: 'ACTION_ADD_ITEM_CLEAR_ALL',
            submit: 'ACTION_ADD_ITEM_SUBMIT',
            modify: 'ACTION_ADD_ITEM_MODIFY',
            fetchList: 'ACTION_ADD_ITEM_FETCH_LIST',
            fetchCheckup: 'ACTION_ADD_ITEM_FETCH_CHECKUP'
        },
        getters: {
            section1: 'GETTER_SECTION_1',
            section2: 'GETTER_SECTION_2',
            section3: 'GETTER_SECTION_3',
            section4: 'GETTER_SECTION_4',
            checkSection1: 'GETTER_CHECK_SECTION_1',
            checkSection2: 'GETTER_CHECK_SECTION_2',
            checkSection3: 'GETTER_CHECK_SECTION_3',
            checkSection4: 'GETTER_CHECK_SECTION_4',
            checkup: 'GETTER_CHECKUP'
        }
    },
    sign: {
        mutations: {
            agreeToken: 'MUTATION_SIGN_AGREE_TOKEN',
            authToken: 'MUTATION_SIGN_AUTH_TOKEN',
            me: 'MUTATION_SIGN_ME'
        },
        actions: {
            agreeToken: 'ACTION_SIGN_AGREE_TOKEN',
            validToken: 'ACTION_SIGN_VALID_TOKEN',
            checkDuplicated: 'ACTION_SIGN_CHECK_DUPLICATED',
            checkAuthToken: 'ACTION_SIGN_CHECK_AUTH_TOKEN',
            authToken: 'ACTION_SIGN_AUTH_TOKEN',
            up: 'ACTION_SIGN_UP',
            in: 'ACTION_SIGN_IN',
            me: 'ACTION_SIGN_ME',
            logout: 'ACTION_SIGN_LOGOUT',
            changeEmail: 'ACTION_SIGN_CHANGE_EMAIL',
            changePassword: 'ACTION_SIGN_CHANGE_PASSWORD'
        },
        getters: {
            agreeToken: 'GETTER_SIGN_AGREE_TOKEN',
            authToken: 'GET_SIGN_AUTH_TOKEN',
            me: 'GET_SIGN_ME'
        }
    },
    report: {
        mutations: {
            list: 'MUTATION_REPORT_LIST',
            detail: 'MUTATION_REPORT_DETAIL'
        },
        actions: {
            fetchList: 'ACTION_REPORT_LIST',
            fetchDetail: 'ACTION_FETCH_DETAIL'
        },
        getters: {
            list: 'GETTER_REPORT_LIST',
            info: 'GETTER_REPORT_INFO',
            detail: 'GETTER_REPORT_DETAIL'
        }
    }
}
